<script>
  import ShowingTags from './ShowingTags.svelte';
  import { photos} from './create_img.js';
  import FullScreenImage from './FullScreenImage.svelte';
  import {
    focused_img,
    show_start_msg,
    show_full_img,
    current_scroll_position,
    filtered_image,
  } from './store.js';
  let c_scroll_position;
  /** @type {number} */
  let y;
  /**@type {boolean}*/
  let full_screen;
  /** @type {boolean}*/
  let show_start_message;
  /** @type {boolean}*/
  let no_img_found;
  /** @type {string[]}*/
  let filtered_tags = [];
  /** @type {number}*/
  let num_of_pic = photos.length;
  /** @type {{ alt: string; src: string; original_path: string;
   * tags: string[]; time: (string | number)[]; hv: boolean; rating: number}[]}*/
  let filtered_img;
  show_full_img.subscribe((value) => {
    full_screen = value;
  });
  current_scroll_position.subscribe((value) => {
    c_scroll_position = value;
  });

  
  /**
   * @param {{ alt: string; src: string; original_path: string; tags: string[];
   * time: (string | number)[]; hv: boolean; rating: number; }} img_param
   */
  function enterFullScreen(img_param) {
    show_full_img.set(true);
    focused_img.set(img_param);
    current_scroll_position.set(y);
  }

  function reorderForPacking(photos) {
    if (typeof window === 'undefined' || photos.length === 0) return photos;

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const containerWidth = vw - 32;
    const itemPadding = 20;

    const estW = (p) =>
      p.hv
        ? Math.min(600, 0.44 * vw) + itemPadding
        : Math.min(500, 0.52 * vh) * 0.667 + itemPadding;

    const n = photos.length;
    const widths = photos.map(estW);
    const placed = new Array(n).fill(false);
    const result = [];
    let rowWidth = 0;

    for (let pos = 0; pos < n; pos++) {
      const pool = [];
      for (let j = Math.max(0, pos - 2); j <= Math.min(n - 1, pos + 2); j++) {
        if (!placed[j]) pool.push(j);
      }

      const urgent = pool.filter((j) => j <= pos - 2);
      const candidates = urgent.length > 0 ? urgent : pool;

      const remaining = containerWidth - rowWidth;
      let best = candidates[0];
      let bestScore = Infinity;

      for (const j of candidates) {
        const w = widths[j];
        const score = w <= remaining ? remaining - w : remaining - w + containerWidth;
        if (score < bestScore) {
          bestScore = score;
          best = j;
        }
      }

      placed[best] = true;
      result.push(photos[best]);
      rowWidth += widths[best];
      if (rowWidth > containerWidth) rowWidth = widths[best];
    }

    return result;
  }

  $: reordered_photos = reorderForPacking($filtered_image);
</script>

<svelte:window bind:scrollY={y} />

<main style="margin: 0px, padding: 0px">
  {#if $show_full_img}
    <FullScreenImage />
  {:else}
    <p class="lastupdatetime">This page was last updated on March 26th, 2026 with {num_of_pic} photos.</p>
    <h1 style="padding-bottom: 10px">Helena Su Photograhpy</h1>

    <br />

    <ShowingTags bind:no_img_found bind:filtered_tags/>

    {#if $show_start_msg}
      <br />
      <p>Click tag category for more tags!</p>
    {/if}

    {#if no_img_found}
      <p>No photos are found!!!!</p>
    {/if}

    <div class="flex-container">
      {#each reordered_photos as a_photo}
        <div class="flex-items">
          {#if a_photo.hv}
            <!-- svelte-ignore a11y-missing-attribute -->
            <img
              class="img_hover"
              {...a_photo}
              style="width:min(600px, 44vw)"
              on:click={() => enterFullScreen(a_photo)}
            />
          {:else}
            <!-- svelte-ignore a11y-missing-attribute -->
            <img
              class="img_hover"
              {...a_photo}
              style="height:min(500px, 52vh)"
              on:click={() => enterFullScreen(a_photo)}
            />
          {/if}
        </div>
      {/each}
    </div>
  {/if}
</main>

<style>
  main {
    /* text-align: center; */
    padding: 1em;
    /* max-width: 240px; */
    /* background-color: beige; */
  }
  @media screen and (max-width: 600px) {
    main {
      padding: 0.25em;
    }
  }
  .lastupdatetime {
    color: #464d4f;
    margin-left: 10px;
    margin-top: 0px;
    text-align: right;
    /* line-height: 1rem; */
    /* font-family: 'Didact Gothic', sans-serif; */
  }

  @media screen and (max-width: 600px) {
    .lastupdatetime {
      font-size: 1rem;
      text-align: center;
      /* width:fit-content; */
    }
  }

  h1 {
    font-family: 'Caudex', serif;
    letter-spacing: 3px;
    font-size: 3rem;
    margin: 0px;
    margin-left: 10px;
    text-align: left;
    color: #d9dbca;
    font-stretch: condensed;
  }
  @media screen and (max-width: 600px) {
    h1 {
      font-size: 2.25rem;
      text-align: center;
    }
  }

  p {
    font-family: 'Piazzolla', serif;
    color: #d9dbca;
    font-size: 1.25rem;
    margin: 20px;
  }
  .description {
    text-align: center;
    vertical-align: middle;
    align-self: center;
    padding-left: 20px;
    padding-right: 20px;
  }
  .checkbox-format {
    display: inline-flex;
    border-color: #919cbf;
  }
  .checkbox-format:hover {
    --exio-hover-border-color: white;
  }

  @media screen and (max-width: 600px) {
  }
  .stretch_h {
    width: 70vw;
  }
  .stretch_v {
    height: 90vh;
  }
  .fullscreen {
    display: grid;
    align-content: center;
    position: relative;
  }
  .img_hover:hover {
    opacity: 0.5;
  }

  img {
    display: block;

    margin-left: auto;
    margin-right: auto;
  }

  @media screen and (max-width: 600px) {
    img {
      width: auto !important;
      height: auto !important;
      max-width: 100%;
      max-height: 25rem;
      object-fit: contain;
      border: none;
    }
  }

  .flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 0px;
    align-items: flex-start;
  }

  .flex-items {
    padding: 10px; /* this */
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
